import IonToolbar from '../../../../../components/Modal/ModalToolbar';
// import '@capacitor-community/http';
import { IonBackButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonPage, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, clipboardOutline, constructOutline, desktopOutline, peopleOutline, personOutline, searchOutline, tabletPortraitSharp } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './MenuCadastros.css';
import iconMoto from "./imgs/moto.svg";

type Props = {
    abrirMenu: boolean;
}

const MenuCadastros: React.FC<Props> = (props: Props) => {

    const history = useHistory();
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");
    const [showToast2, setShowToast2] = useState(false);
    const [showPerfil, setShowPerfil] = useState(false);

    const [perfil, setPerfil] = useState<any>("clientes");
    const { loja, setLoja } = useContext(MessageContext);

    const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const { nomeMenu, setNomeMenu } = useContext(MessageContext);

    useIonViewDidEnter(() => {
        setEsconderMenu(true);
        setNomeMenu("");

    });

    return (
        <IonPage className="menu-layout-page">
            <IonHeader className="ion-no-border">
                <IonToolbar className="menu-layout-toolbar">
                    <IonButtons slot="start">
                        <IonBackButton icon={arrowBack} text=''></IonBackButton>
                    </IonButtons>
                    <IonTitle slot="start">Cadastros</IonTitle>

                </IonToolbar>
            </IonHeader>

            <IonContent className="menu-layout-content">
                <div className="menu-layout-container">
                    <div className="menu-layout-heading">
                        <h1>Cadastros</h1>
                        <p>Gerencie sua equipe, clientes e os cadastros da sua operação.</p>
                    </div>
                    <nav className="menu-layout-grid" aria-label="Cadastros">
                        <IonItem className="menu-layout-item" lines="none" button routerLink="/empresa/equipe" routerDirection="forward" detail hidden={acessos?.cadastros != 'leitura' && acessos?.cadastros != 'edicao'}>
                            <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={peopleOutline} />
                            <IonLabel><h2>Usuários</h2><p>Equipe e permissões de acesso</p></IonLabel>
                        </IonItem>
                        {(acessos?.vendas == 'leitura' || acessos?.vendas == 'edicao') && (
                            <IonItem className="menu-layout-item" lines="none" button routerLink="/empresa/prospects" routerDirection="forward" detail hidden={acessos?.cadastros != 'leitura' && acessos?.cadastros != 'edicao'}>
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={searchOutline} />
                                <IonLabel><h2>Prospects</h2><p>Contatos e oportunidades de venda</p></IonLabel>
                            </IonItem>
                        )}
                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <IonItem className="menu-layout-item" lines="none" button routerLink="/empresa/usuariostotem" routerDirection="forward" detail hidden={acessos?.cadastros != 'leitura' && acessos?.cadastros != 'edicao'}>
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={tabletPortraitSharp} />
                                <IonLabel><h2>Totem</h2><p>Acessos ao autoatendimento</p></IonLabel>
                            </IonItem>
                        )}
                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <IonItem className="menu-layout-item" lines="none" button routerLink="/empresa/usuarioscaixa" routerDirection="forward" detail hidden={acessos?.cadastros != 'leitura' && acessos?.cadastros != 'edicao'}>
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={desktopOutline} />
                                <IonLabel><h2>Balcão</h2><p>Acessos ao atendimento no balcão</p></IonLabel>
                            </IonItem>
                        )}
                        {(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") && (
                            <IonItem className="menu-layout-item" lines="none" button routerLink="/empresa/usuarioscomandas" routerDirection="forward" detail hidden={acessos?.cadastros != 'leitura' && acessos?.cadastros != 'edicao'}>
                                <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={clipboardOutline} />
                                <IonLabel><h2>{window.localStorage.getItem("nomeInternoMesasOuComandas") || "Mesas"}</h2><p>Acessos ao atendimento da loja</p></IonLabel>
                            </IonItem>
                        )}
                        <IonItem className="menu-layout-item" lines="none" button routerLink="/empresa/clientes" routerDirection="forward" detail hidden={acessos?.cadastros != 'leitura' && acessos?.cadastros != 'edicao'}>
                            <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={personOutline} />
                            <IonLabel><h2>Clientes</h2><p>Dados e contatos dos clientes</p></IonLabel>
                        </IonItem>
                        <IonItem className="menu-layout-item" lines="none" button routerLink="/empresa/prestadores" routerDirection="forward" detail hidden={acessos?.cadastros != 'leitura' && acessos?.cadastros != 'edicao'}>
                            <IonIcon className="menu-layout-icon" aria-hidden="true" slot="start" icon={(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") ? iconMoto : constructOutline} />
                            <IonLabel><h2>{(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas") ? "Entregadores" : "Prestadores"}</h2><p>Profissionais que atendem sua operação</p></IonLabel>
                        </IonItem>

                    </nav>
                </div>

                <IonToast
                    isOpen={showToast}
                    position="middle" //top, bottom, middle
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                />
            </IonContent>

        </IonPage>
    );
};

export default MenuCadastros;
